import { render, staticRenderFns } from "./Toexamine.vue?vue&type=template&id=9c605388"
import script from "./Toexamine.vue?vue&type=script&lang=js"
export * from "./Toexamine.vue?vue&type=script&lang=js"
import style0 from "./Toexamine.vue?vue&type=style&index=0&id=9c605388&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports